import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  REPORTS_EXPORT_OOS_REPORT_BY_SITE_BEGIN,
  REPORTS_EXPORT_OOS_REPORT_BY_SITE_SUCCESS,
  REPORTS_EXPORT_OOS_REPORT_BY_SITE_FAILURE,
  REPORTS_EXPORT_OOS_REPORT_BY_SITE_DISMISS_ERROR,
} from './constants';
import { EXPORT_API_REQUEST_URL } from '../../../common/apiConfig';
export function exportOosReportBySite(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: REPORTS_EXPORT_OOS_REPORT_BY_SITE_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(`${EXPORT_API_REQUEST_URL}/orderDetail/exportOosReportBySite`, args);
      doRequest.then(
        (res) => {
          dispatch({
            type: REPORTS_EXPORT_OOS_REPORT_BY_SITE_SUCCESS,
            data: res.data.data,
          });
          resolve(res.data.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: REPORTS_EXPORT_OOS_REPORT_BY_SITE_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissExportOosReportBySiteError() {
  return {
    type: REPORTS_EXPORT_OOS_REPORT_BY_SITE_DISMISS_ERROR,
  };
}

export function useExportOosReportBySite() {
  const dispatch = useDispatch();

  const { exportOosReportBySitePending, exportOosReportBySiteError } = useSelector(
    state => ({
      exportOosReportBySitePending: state.reports.exportOosReportBySitePending,
      exportOosReportBySiteError: state.reports.exportOosReportBySiteError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(exportOosReportBySite(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissExportOosReportBySiteError());
  }, [dispatch]);

  return {
    exportOosReportBySite: boundAction,
    exportOosReportBySitePending,
    exportOosReportBySiteError,
    dismissExportOosReportBySiteError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case REPORTS_EXPORT_OOS_REPORT_BY_SITE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        exportOosReportBySitePending: true,
        exportOosReportBySiteError: null,
      };

    case REPORTS_EXPORT_OOS_REPORT_BY_SITE_SUCCESS:
      // The request is success
      return {
        ...state,
        exportOosReportBySitePending: false,
        exportOosReportBySiteError: null,
      };

    case REPORTS_EXPORT_OOS_REPORT_BY_SITE_FAILURE:
      // The request is failed
      return {
        ...state,
        exportOosReportBySitePending: false,
        exportOosReportBySiteError: action.data.error,
      };

    case REPORTS_EXPORT_OOS_REPORT_BY_SITE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        exportOosReportBySiteError: null,
      };

    default:
      return state;
  }
}
